import React, { useEffect, useState } from 'react';

const N8N_LINKEDIN_AUTH =
  import.meta.env.VITE_N8N_LINKEDIN_AUTH || 'https://n8n.akodigitale.fr/webhook/linkedin-auth';

const LinkedInCallback = ({ code }) => {
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    const exchange = async () => {
      try {
        const res = await fetch(N8N_LINKEDIN_AUTH, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirect_uri: window.location.origin + '/callback',
          }),
        });
        const data = await res.json();
        if (!res.ok || !data.access_token) {
          throw new Error(data.error || 'Token non reçu');
        }
        localStorage.setItem('linkedin_token', data.access_token);
        localStorage.setItem('linkedin_name', data.name || '');
        localStorage.setItem('linkedin_sub', data.sub || '');
        setStatus('success');
        setTimeout(() => { window.location.href = '/'; }, 2000);
      } catch (e) {
        setError(e.message);
        setStatus('error');
      }
    };
    exchange();
  }, [code]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#0f172a', color: 'white',
      flexDirection: 'column', gap: '1rem', fontFamily: 'sans-serif',
    }}>
      {status === 'loading' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>⏳</div>
          <p style={{ color: '#94a3b8' }}>Connexion LinkedIn en cours...</p>
        </>
      )}
      {status === 'success' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>✅</div>
          <p style={{ color: '#34d399', fontWeight: '600' }}>LinkedIn connecté avec succès !</p>
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>Redirection en cours...</p>
        </>
      )}
      {status === 'error' && (
        <>
          <div style={{ fontSize: '2.5rem' }}>❌</div>
          <p style={{ color: '#fca5a5', fontWeight: '600' }}>Erreur de connexion</p>
          {error && <p style={{ color: '#64748b', fontSize: '0.85rem' }}>{error}</p>}
          <a href="/" style={{ color: '#60a5fa', fontSize: '0.9rem' }}>Retour au dashboard</a>
        </>
      )}
    </div>
  );
};

export default LinkedInCallback;
